<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import CompanySelector from 'dashboard/components-next/Companies/CompanySelector.vue';

// Empresas do contato (N:N). A primeira é a principal: é a que aparece nos
// filtros, ordenação e automações (company_name). Remover a principal promove
// a próxima; o backend aplica a mesma regra.
const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
  isDetailsView: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const companies = computed(() => props.modelValue || []);

const handleSelect = ({ id, name }) => {
  if (!id) return;
  const numericId = Number(id);
  if (companies.value.some(company => Number(company.id) === numericId)) return;
  emit('update:modelValue', [...companies.value, { id: numericId, name }]);
};

const removeCompany = id => {
  emit(
    'update:modelValue',
    companies.value.filter(company => Number(company.id) !== Number(id))
  );
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <ul
      v-if="companies.length"
      class="flex flex-wrap gap-1.5 m-0 p-0 list-none"
    >
      <li
        v-for="(company, index) in companies"
        :key="company.id"
        class="inline-flex items-center gap-1 h-7 pl-2.5 pr-1 rounded-lg text-sm bg-n-alpha-2 text-n-slate-12"
      >
        <span class="i-ph-building-light size-3.5 text-n-slate-10" />
        <span class="truncate max-w-48">{{ company.name }}</span>
        <span
          v-if="index === 0 && companies.length > 1"
          class="text-xs text-n-slate-11"
        >
          {{ `· ${t('COMPANIES.CONTACT_FIELD.PRIMARY')}` }}
        </span>
        <button
          type="button"
          class="flex items-center justify-center size-5 rounded-md text-n-slate-10 hover:text-n-slate-12 hover:bg-n-alpha-3"
          :title="t('COMPANIES.CONTACT_FIELD.REMOVE')"
          :aria-label="t('COMPANIES.CONTACT_FIELD.REMOVE')"
          @click="removeCompany(company.id)"
        >
          <span class="i-lucide-x size-3.5" />
        </button>
      </li>
    </ul>
    <CompanySelector
      model-value=""
      selected-name=""
      :is-details-view="isDetailsView"
      @select="handleSelect"
    />
  </div>
</template>
